module.exports = __webpack_public_path__ + "static/media/HCMM147.1e0c8635.jpg";